<template>
  <div class="top">
    <el-row>
      <el-col :span="4">
        <div class="top_logo">
          <img :src="require('@/assets/img/logo.png')" />
        </div>
      </el-col>
      <el-col :span="20">
        <div class="header_content">
          <div class="top_nav">
            <div
              v-show="item.isShow"
              v-for="(item, index) of navList"
              :key="index"
              :class="{ top_active: $store.getters.getIsAction === item.id }"
              @click="changeNavClass(index, item.id)"
            >
              <span v-show="item.isShow">{{ item.name }}</span>
            </div>
            <!-- <el-tabs v-model="activeName" @tab-click="handleClick">
              <el-tab-pane label="用户管理" name="first">用户管理</el-tab-pane>
              <el-tab-pane label="配置管理" name="second">配置管理</el-tab-pane>
              <el-tab-pane label="角色管理" name="third">角色管理</el-tab-pane>
              <el-tab-pane label="定时任务补偿" name="fourth">定时任务补偿</el-tab-pane>
            </el-tabs> -->
          </div>
          <div class="top_user">
            <div class="company_info">
              <!-- 公司信息 -->
              <span class="el-dropdown-link" v-if="!companyState">
                暂无企业<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown v-if="companyState">
                <span class="el-dropdown-link">
                  {{ companyData.companyName
                  }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <div class="company_info_detail">
                    <div class="company_info_title">
                      {{ companyData.companyName }}
                    </div>
                    <div class="company_info_content">
                      <div class="company_content_state">
                        <div class="company_state_left display_flex">
                          <!-- <i class="iconfont">&#xe65e;</i> -->
                          <img
                            class="icon_pic"
                            :src="require('@/assets/img/top_dsxx.png')"
                            alt=""
                          />
                          <span>工商信息：</span>
                          <em
                            :class="
                              companyData.businessInfoStatusDesc == '有效'
                                ? 'green'
                                : 'red'
                            "
                            >{{ companyData.businessInfoStatusDesc }}</em
                          >
                        </div>
                        <div
                          class="company_state_right"
                          @click="
                            toPath('/supplierWorkbench/companiesResume', 4)
                          "
                        >
                          企业简历
                        </div>
                      </div>
                      <div class="company_content_state">
                        <div class="company_state_left display_flex">
                          <!-- <i class="iconfont">&#xe628;</i> -->
                          <img
                            class="icon_pic"
                            :src="require('@/assets/img/top_wts.png')"
                            alt=""
                          />
                          <span>委托书：</span>
                          <em
                            :class="
                              companyData.grantWarrantStatusDesc == '有效'
                                ? 'green'
                                : 'red'
                            "
                            >{{ companyData.grantWarrantStatusDesc }}</em
                          >
                        </div>
                        <div
                          class="company_state_right"
                          @click="
                            toPath('/supplierWorkbench/personalCenter', 5)
                          "
                        >
                          变更
                        </div>
                      </div>
                      <!-- <div class="company_content_state">
                        <div class="company_state_left display_flex">
                          <img
                            class="icon_pic"
                            :src="require('@/assets/img/top_szzs.png')"
                            alt=""
                          />
                          <span>数字证书：</span>
                          <em
                            :class="
                              companyData.digitalCertificateStatusDesc ==
                              '已开通'
                                ? 'green'
                                : 'red'
                            "
                            >{{ companyData.digitalCertificateStatusDesc }}</em
                          >
                        </div>
                        <div
                          class="company_state_right"
                          @click="
                            toPath('/supplierWorkbench/digitalCertificate', 4)
                          "
                        >
                          管理
                        </div>
                      </div> -->
                      <div class="company_content_state">
                        <div class="company_state_left display_flex">
                          <!-- <i class="iconfont">&#xe613;</i> -->
                          <img
                            class="icon_pic"
                            :src="require('@/assets/img/top_whpzz.png')"
                            alt=""
                          />
                          <span>危化品资质：</span>
                          <em
                            :class="
                              hazardousChemicalSubstance == '20'
                                ? 'green'
                                : 'red'
                            "
                          >
                            {{
                              hazardousChemicalSubstance == "10"
                                ? "草稿"
                                : hazardousChemicalSubstance == "20"
                                ? "有效 "
                                : hazardousChemicalSubstance == "30"
                                ? "过期"
                                : hazardousChemicalSubstance == "40"
                                ? "待审核"
                                : hazardousChemicalSubstance == "50"
                                ? "审核驳回"
                                : hazardousChemicalSubstance == "60"
                                ? "未上传"
                                : "--"
                            }}
                          </em>
                        </div>
                        <div
                          class="company_state_right"
                          @click="
                            toPath(
                              '/supplierWorkbench/qualificationCertificate',
                              4,
                              'hazardousChemicalSubstance'
                            )
                          "
                        >
                          管理
                        </div>
                      </div>
                    </div>
                    <div class="company_info_center" v-if="false">
                      <div class="company_center_state mb5px">
                        <div class="company_state_left">
                          <span>东方付通：</span>
                          <em
                            :class="
                              companyData.orientalTenpayStatusDesc == '已认证'
                                ? 'green'
                                : 'red'
                            "
                            >{{ companyData.orientalTenpayStatusDesc }}</em
                          >
                        </div>
                        <div
                          class="company_state_right"
                          v-if="
                            companyData.orientalTenpayStatusDesc == '已认证'
                          "
                        >
                          <a
                            style="margin: 0 5px 0 0"
                            href="https://www.easternpay.com.cn/dfft/zhcz.html"
                            target="_blank"
                            >充值</a
                          ><span style="margin: 0 5px 0 0" @click="queryToPath"
                            >流水查询</span
                          >
                          <a
                            href="https://www.easternpay.com.cn/dfft/zhcz.html"
                            target="_blank"
                            >提现</a
                          >
                        </div>
                        <div
                          class="company_state_right"
                          v-if="
                            companyData.orientalTenpayStatusDesc ==
                            '你尚未开通付通！'
                          "
                        >
                          <a
                            style="margin: 0 5px 0 0"
                            :href="
                              cookieBase +
                              '/chem-pay-web/authentication/toAccountPage?type=1'
                            "
                            target="_blank"
                            >快速开通(认证)</a
                          >
                        </div>
                      </div>
                      <div class="fz10px">
                        总金额：<span
                          :class="companyData.totalAmount ? 'green' : 'red'"
                          >{{
                            companyData.totalAmount
                              ? companyData.totalAmount
                              : 0
                          }}</span
                        >元（可用：{{
                          companyData.availableAmount
                            ? companyData.availableAmount
                            : 0
                        }}元）
                      </div>
                      <div class="fz10px">
                        锁定：<span
                          :class="companyData.lockAmount ? 'green' : 'red'"
                          >{{
                            companyData.lockAmount ? companyData.lockAmount : 0
                          }}</span
                        >元&nbsp;&nbsp;挂账：{{
                          companyData.paymentAmount
                            ? companyData.paymentAmount
                            : 0
                        }}元
                      </div>
                    </div>
                    <!-- <div class="company_info_right">
                      <div class="company_center_state">
                        <div class="company_state_left">
                          <span>XXX有限公司</span>
                        </div>
                        <div class="company_state_right"><span>切换</span></div>
                      </div>
                      <div class="company_center_state">
                        <div class="company_state_left">
                          <span>XXX有限公司</span>
                        </div>
                        <div class="company_state_right"><span>切换</span></div>
                      </div>
                    </div> -->
                  </div>
                </el-dropdown-menu>
              </el-dropdown>
              <!-- 小程序二维码 -->
              <!--							<el-dropdown>-->
              <!--								<span class="el-dropdown-link">-->
              <!--									<i class="el-icon-full-screen"></i>-->
              <!--								</span>-->
              <!--								<el-dropdown-menu slot="dropdown">-->
              <!--									<div class="QR_code">-->
              <!--										<img :src="require('@/assets/img/QR_code.svg')" alt="" />-->
              <!--										<span>宝武碳业客商服务小程序</span>-->
              <!--									</div>-->
              <!--								</el-dropdown-menu>-->
              <!--							</el-dropdown>-->
              <!-- 支持信息 -->
              <el-dropdown>
                <span class="el-dropdown-link display_flex">
                  <img
                    class="icon_pic"
                    :src="require('@/assets/img/top_zhichi.png')"
                    alt=""
                  />
                  支持<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <div class="supporting_box">
                    <div class="supporting_info">
                      <!-- <i class="el-icon-phone-outline">服务热线：</i> -->
                      <img
                        class="icon_pic"
                        :src="require('@/assets/img/top_fwrx.png')"
                        alt=""
                      />服务热线：
                      <span>400-820-6662</span>
                    </div>
                  </div>
                </el-dropdown-menu>
              </el-dropdown>
              <!-- 用户信息 -->
              <el-dropdown>
                <span class="el-dropdown-link display_flex">
                  <!-- <i class="el-icon-user"></i> -->
                  <img
                    class="icon_pic"
                    :src="require('@/assets/img/top_user.png')"
                    alt=""
                  />
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <div class="user_info">
                    <div class="user_info_name">
                      <span>{{ info.nickname }}</span>
                      <i
                        class="el-icon-setting blue"
                        @click="toPath('/supplierWorkbench/personalCenter', 5)"
                        style="cursor: pointer"
                      ></i>
                    </div>
                    <div class="user_info_bt">
                      <span
                        >用户账号：<em>{{ info.username }}</em></span
                      >
                      <!--											<em class="blue" @click="toPath('/supplierWorkbench/personalCenter', 4)">修改</em>-->
                    </div>
                    <div class="user_info_bt">
                      <span
                        >手机号：<em>{{ info.mobiles }}</em></span
                      >
                      <!--											<em class="blue" @click="toPath('/supplierWorkbench/personalCenter', 4)">修改</em>-->
                    </div>
                    <div class="user_dotted"></div>
                    <div class="user_info_bt">
                      <span class="display_flex">
                        <img
                          class="icon_pic"
                          :src="require('@/assets/img/top_sqwts.png')"
                          alt=""
                        />授权委托书:<span
                          :class="info.grantWarrantStatus ? 'green' : 'red'"
                          >{{ info.grantWarrantStatus ? "有效" : "无效" }}</span
                        ></span
                      >
                      <!-- <em class="blue">重新提交</em> -->
                    </div>
                    <div class="user_info_bt">
                      <span
                        class="display_flex"
                        @click="
                          toPath1(
                            '/supplierWorkbench/personalCenter/changePassword',
                            5,
                            info.mobile
                          )
                        "
                      >
                        <!-- <i class="iconfont">&#xe8cf;</i> -->
                        <img
                          class="icon_pic"
                          :src="require('@/assets/img/top_xgmm.png')"
                          alt=""
                        />修改密码</span
                      >
                    </div>
                    <div class="user_info_bt">
                      <span @click="removeLogin" class="display_flex">
                        <!-- <i class="iconfont">&#xe611;</i>  -->
                        <img
                          class="icon_pic"
                          :src="require('@/assets/img/top_tcdl.png')"
                          alt=""
                        />退出登录</span
                      >
                    </div>
                  </div>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <!-- 抽屉 -->
    <el-drawer
      :visible.sync="isDrawer"
      direction="rtl"
      :before-close="handleClose"
    >
      <template slot="title">
        <div class="drawer_title">
          <div class="drawer_title_left">消息中心</div>
          <div class="drawer_title_right">
            <span class="mr5px">查看更多</span>
            <span>订阅管理</span>
          </div>
        </div>
      </template>
      <div class="message">
        <div class="message_item">
          <div class="message_item_top">
            <span class="unread wathet">网站公告</span>
            <em>2022-05-01 15:31:27</em>
          </div>
          <div class="message_item_bottom">
            <span>端午节放假通知</span>
          </div>
        </div>
        <div class="message_item">
          <div class="message_item_top">
            <span class="unread blue">网站公告</span>
            <em>2022-05-01 15:31:27</em>
          </div>
          <div class="message_item_bottom">
            <span>端午节放假通知</span>
            <el-link type="primary">标记已读</el-link>
          </div>
        </div>
        <div class="message_item">
          <div class="message_item_top">
            <span class="gray">网站公告</span>
            <em>2022-05-01 15:31:27</em>
          </div>
          <div class="message_item_bottom">
            <span>端午节放假通知</span>
          </div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import { cookieBase, base3xHarf } from "@/api/base"; // 导入接口域名列表
export default {
  props: ["navList"],
  data() {
    return {
      base3xHarf: base3xHarf(),
      cookieBase: cookieBase(),
      isDrawer: false,
      // 安全生产许可证
      safetyProduction: "",
      // 危险品
      hazardousChemicalSubstance: "",
      info: {},
      companyData: {},
      companyState: false,
    };
  },
  mounted() {
    this.init();
    //获取当前登录人信息
    this.getCertificateState();
    this.$api.client.getPersonInfoMe().then((res) => {
      // console.log(res);
      if (res.code == "1") {
        if (res.data.mobile) {
          res.data.mobiles = res.data.mobile.replace(
            /(\d{3})\d{4}(\d{4})/,
            "$1****$2"
          );
        }
        this.info = res.data;
      }
    });
    // 头部获取企业信息
    this.$api.client.getCurrentCompany().then((res) => {
      // console.log(res.data);
      if (res.code == "1") {
        this.companyData = res.data;
        this.companyState = true;
      }
    });
  },
  methods: {
    //退出登录
    removeLogin() {
      // this.$api.user.getloginLogout().then((res) => {
      //   localStorage.clear();
      // });
      this.$router.push("/");
      this.$store.commit("set_menu_detail_list", []);
      this.$message.error("已退出登录");
    },

    // 初始化
    init() {},
    // 切换工作台
    changeNavClass(i, val) {
      // let getIsView=this.$store.getters.getIsView
      // console.log(i,val);
      // var list = this.$store.getters.menuDetailList[i];
      var list = null;
      let indexs = null;
      // console.log(this.$store.getters.menuDetailList);
      let listDat = this.$store.getters.menuDetailList;
      listDat.forEach((item, index) => {
        if (item.path == val) {
          list = item;
          indexs = index;
        }
      });
      if (!list) {
        this.$message.warning("暂无权限!");
        return;
      }
      this.$store.commit("set_is_active", val);

      if (list.children && list.children.length) {
        const path = list.children[0].routerPath;
        if (this.$route.path == path) return false;
        // this.$router.push(path);
        // this.$emit('changeAction',path)
        // if (i == 2) {
        // if (this.$route.path == "/carrierWorkbench/arrivalManagement") return false;
        // this.$router.push("/carrierWorkbench/arrivalManagement");
        // this.$emit("changeAction", "/carrierWorkbench/arrivalManagement");
        // } else {
        this.$router.push(path);
        this.$emit("changeAction", path);
        // }
      }
      let vw = document.body.clientWidth;
      if (vw < 1350) this.$store.commit("set_is_view", true);
      else this.$store.commit("set_is_view", false);
      // this.$store.commit("set_is_view", getIsView);
      this.$store.commit("set_menu_list", list.children);
    },
    // 关闭抽屉
    handleClose() {
      this.isDrawer = false;
    },
    // 跳转页面
    toPath(val, i, item) {
      if (val == "/supplierWorkbench/personalCenter") {
        let time = Math.floor(Date.now() / 1000) + 3600;
        this.$api.user
          .getShortUrl({
            rawUrl: this.base3xHarf + "/workspace/info",
            userId: JSON.parse(localStorage.getItem("companyInfo")).userId,
            orgId: JSON.parse(localStorage.getItem("companyInfo")).orgId,
            name: JSON.parse(localStorage.getItem("companyInfo")).loginname,
            tenantId: 0,
            expiredAt: time,
          })
          .then((res) => {
            if (res.status == "200") {
              this.noAttest = false;
              this.companyAttest = false;
              window.open(res.data, "block");
            } else {
              this.$message.error(res.msg);
            }
          });
      } else {
        var list = null;
        // console.log(this.$store.getters.menuDetailList);
        let listDat = this.$store.getters.menuDetailList;
        // console.log(listDat);
        listDat.forEach((ment) => {
          if (ment.routerPath == val) {
            list = ment;
          }
          if (ment.children) {
            ment.children.forEach((sum) => {
              if (sum.routerPath == val) {
                list = sum;
              }
              if (sum.children) {
                sum.children.forEach((cont) => {
                  if (cont.routerPath == val) {
                    list = cont;
                  }
                });
              }
            });
          }
        });
        if (!list) {
          this.$message.warning("暂无权限!");
          return;
        }
        this.$store.commit("set_is_active", i);
        this.$emit("changeAction", val);
        let setMenuList = [];
        this.$store.getters.menuDetailList.map((e) => {
          if (i + 1 == e.routerPath) setMenuList = e.children;
        });
        this.$store.commit("set_menu_list", setMenuList);
        // this.$store.commit("set_menu_list", this.$store.getters.menuDetailList[i].children);
        if (item) {
          if (item == "safetyProduction") {
            if (this.safetyProduction) {
              // 安全生产许可证
              if (this.safetyProduction == "60") {
                this.$router.push({
                  name: "supplierWorkbench_addQualificationCertificate",
                  params: {
                    id: "add",
                    certificateType: "02",
                  },
                });
              } else {
                this.$router.push({
                  name: "supplierWorkbench_qualificationCertificate",
                  params: {
                    value: "02",
                  },
                });
              }
            }
          } else {
            if (this.hazardousChemicalSubstance) {
              // 危险品
              if (this.hazardousChemicalSubstance == "60") {
                this.$router.push({
                  name: "supplierWorkbench_addQualificationCertificate",
                  params: {
                    id: "add",
                    certificateType: "03",
                  },
                });
              } else {
                this.$router.push({
                  name: "supplierWorkbench_qualificationCertificate",
                  params: {
                    value: "03",
                  },
                });
              }
            }
          }
        } else {
          this.$router.push(val);
        }
      }
    },
    // 证书状态
    getCertificateState() {
      this.$api.client.getChemicalsgetCertificateState({}).then((res) => {
        // console.log(res);
        if (res.code == "1") {
          this.safetyProduction = res.data.safety;
          this.hazardousChemicalSubstance = res.data.danger;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 修改密码
    toPath1(val, i, item) {
      this.$store.commit("set_is_active", i);
      this.$emit("changeAction", val);
      this.$router.push(val + "?mobile=" + item);
    },
    // 流水查询
    queryToPath() {
      let data = localStorage
        .getItem("token")
        .slice(0, localStorage.getItem("token").indexOf("@"));
      window.open(
        this.cookieBase +
          "/chem-bdt-web/payment/initPaymentList?access_token=" +
          data +
          "&appCode=HGB&flag="
      );
    },
  },
};
</script>
<style scoped>
ul,
li {
  width: auto;
  height: auto;
}
em {
  font-style: normal;
}
.blue {
  color: #004593;
}
.green {
  color: #67c23a;
}
.gray {
  color: #c0c4cc;
}
.fz10px {
  font-size: 10px;
}
.mr5px {
  margin-right: 5px;
}
.mb5px {
  margin-bottom: 5px;
}
.header_content {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.top_user {
  display: flex;
}
::v-deep .popper__arrow {
  display: none;
}
.el-dropdown-menu {
  margin: 0;
  padding: 0;
  border-radius: 0;
  background: #f2f6f7;
}
.el-dropdown-menu.el-popper {
  z-index: 99999 !important;
}
/*  */
.company_info_detail {
  width: 300px;
}
.company_info_title {
  padding: 10px 0 10px 20px;
  font-size: 16px;
  color: #666;
  background: rgba(189, 218, 248, 0.267);
}
.company_info_content {
  padding: 0 20px;
  padding-bottom: 20px;
}
.company_content_state,
.company_center_state {
  font-size: 12px;
  line-height: 2;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.company_state_left {
  color: #999;
}
.company_state_left i {
  margin: 0 5px 0 0;
}
.company_state_right {
  color: #004593;
  cursor: pointer;
}
.company_state_right a {
  color: #004593 !important;
  cursor: pointer;
}
.company_info_center,
.company_info_right {
  margin: 5px 20px;
  padding: 5px 0 10px 18px;
  font-size: 12px;
  line-height: 1.5;
  color: #999;
}

.company_info_center {
  border-top: 1px dotted #666;
  border-bottom: 1px dotted #666;
  margin-left: 0;
}
.QR_code {
  width: 168px;
  height: 172px;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: space-around;
  font-size: 12px;
  color: #999;
}
.QR_code > img {
  display: block;
  width: 125px;
  height: 125px;
}
.supporting_box {
  padding: 15px;
  width: 200px;
}
.supporting_info {
  display: flex;
  align-items: center;
  /* justify-content: space-between; */
  line-height: 2;
  font-size: 14px;
  color: #999;
}
.supporting_info span {
  color: #004593;
}
.user_info {
  padding: 15px;
  width: 200px;
  font-size: 12px;
}
.user_info_name {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 16px;
  color: #333;
}
.user_info_name i {
  font-size: 20px;
}
.user_info_bt {
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  line-height: 2;
  color: #666;
  cursor: pointer;
}
.user_info_bt span:hover {
  color: #004593;
}
.user_info_bt span em {
  color: #004593;
}
.user_dotted {
  margin: 10px 0;
  border-bottom: 1px dotted #666;
}
/* 抽屉信息 */
.drawer_title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #666;
}
.drawer_title_left {
  font-size: 16px;
}
.drawer_title_right {
  font-size: 12px;
}
/* 抽屉消息 */
.message_item {
  padding: 10px 10px 15px 30px;
  height: 66px;
  border-bottom: 1px solid #eee;
  font-size: 12px;
  line-height: 1;
}
.message_item_top {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.message_item_top > span {
  padding: 3px;
  position: relative;
  border-radius: 10px;
}
.message_item_top > span.wathet {
  color: #002da0;
  background: rgba(213, 231, 255, 1);
  border: 1px solid rgba(215, 218, 226, 1);
}
.message_item_top > span.blue {
  color: #fff;
  background: rgba(0, 110, 255, 1);
  border: 1px solid rgba(215, 218, 226, 1);
}
.message_item_top > span.gray {
  color: #fff;
  background: rgba(231, 234, 239, 1);
  border: 1px solid rgba(215, 218, 226, 1);
}
.message_item_top > span.unread::after {
  width: 6px;
  height: 6px;
  content: "";
  position: absolute;
  top: 50%;
  left: -10px;
  background: rgba(0, 110, 255, 1);
  transform: translate3d(0, -50%, 0);
  border-radius: 50%;
}
.message_item_bottom {
  margin-top: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.message_item_bottom a {
  font-size: 12px;
}
.red {
  color: rgb(217, 0, 27);
}
</style>
